// The Activity Log guide (20_ActivityLog.jsx · ModuleHelp, Max 01/11).
const en = {
  viewsT: 'Log or Deleted',
  viewsB: 'Log lists every change made in the portal; Deleted keeps what was removed, so you can open it and see what it held. Reload fetches the latest rows.',
  filtersT: 'Narrow the log',
  filtersB: 'Search by text, then pick an area and an action. The count shows how many rows match out of the total.',
  tableT: 'One row per change',
  tableB: 'Each row gives the time, area, action, who did it, the record and field, and the old and new value.',
  byT: 'Who and through which door',
  byB: 'Besides the person, it says whether the change came from a screen, Catchy or the system, with the IP and browser when they are known.',
};
const ko = {
  viewsT: '로그 또는 삭제됨',
  viewsB: '로그는 포털에서 이뤄진 모든 변경을 보여 주고, 삭제됨은 지워진 항목을 보관해 열어서 내용을 확인할 수 있습니다. 새로고침은 최신 행을 가져옵니다.',
  filtersT: '로그 좁혀 보기',
  filtersB: '텍스트로 검색한 뒤 영역과 작업을 고릅니다. 건수는 전체 중 조건에 맞는 행 수입니다.',
  tableT: '변경당 한 행',
  tableB: '각 행에 시간, 영역, 작업, 수행자, 대상 레코드와 필드, 이전 값과 새 값이 표시됩니다.',
  byT: '누가, 어떤 경로로',
  byB: '수행자와 함께 변경이 화면, Catchy, 시스템 중 어디에서 왔는지 표시하고, 알 수 있는 경우 IP와 브라우저도 보여 줍니다.',
};
const vi = {
  viewsT: 'Log hoặc Đã xóa',
  viewsB: 'Log liệt kê mọi thay đổi trong portal; Đã xóa giữ lại những gì đã bị xóa để bạn mở ra xem nội dung. Tải lại lấy các dòng mới nhất.',
  filtersT: 'Thu hẹp log',
  filtersB: 'Tìm theo chữ, rồi chọn khu vực và thao tác. Số đếm cho biết có bao nhiêu dòng khớp trên tổng số.',
  tableT: 'Mỗi thay đổi một dòng',
  tableB: 'Mỗi dòng ghi thời gian, khu vực, thao tác, người thực hiện, bản ghi và trường, cùng giá trị cũ và mới.',
  byT: 'Ai làm và qua cửa nào',
  byB: 'Ngoài người thực hiện, dòng còn cho biết thay đổi đến từ màn hình, Catchy hay hệ thống, kèm IP và trình duyệt khi có.',
};
const zh = {
  viewsT: '日志或已删除',
  viewsB: '日志列出门户中的每一次变更；已删除保留被删掉的内容，可展开查看其中的数据。刷新会获取最新的记录。',
  filtersT: '缩小日志范围',
  filtersB: '先按文字搜索，再选择区域和操作。计数显示符合条件的行数及总数。',
  tableT: '每次变更一行',
  tableB: '每一行包含时间、区域、操作、操作人、记录和字段，以及旧值和新值。',
  byT: '谁，通过哪个入口',
  byB: '除了操作人，还会说明变更来自页面、Catchy 还是系统；已知时会附上 IP 和浏览器。',
};
const dictionary = { ns: 'tourActivity', en, ko, vi, zh };
export default dictionary;
